export const EMAIL_CHECK__REQUEST = 'PASSWORD_RESET__REQUEST' as const;
export const EMAIL_CHECK__SUCCESS = 'PASSWORD_RESET__SUCCESS' as const;
export const EMAIL_CHECK__FAILURE = 'PASSWORD_RESET__FAILURE' as const;
export const EMAIL_CHECK__RESET = 'PASSWORD_RESET__RESET' as const;
export const REGISTER__REQUEST = 'REGISTER__REQUEST' as const;
export const REGISTER__SUCCESS = 'REGISTER__SUCCESS' as const;
export const REGISTER__FAILURE = 'REGISTER__FAILURE' as const;
export const REGISTER__RESET = 'REGISTER__RESET' as const;
export const RESET_PASSWORD__REQUEST = 'RESET_PASSWORD__REQUEST' as const;
export const RESET_PASSWORD__SUCCESS = 'RESET_PASSWORD__SUCCESS' as const;
export const RESET_PASSWORD__FAILURE = 'RESET_PASSWORD__FAILURE' as const;
export const RESET_PASSWORD__RESET = 'RESET_PASSWORD__RESET' as const;
export const REFRESH_TOKEN__REQUEST = 'REFRESH_TOKEN__REQUEST' as const;
export const REFRESH_TOKEN__SUCCESS = 'REFRESH_TOKEN__SUCCESS' as const;
export const REFRESH_TOKEN__FAILURE = 'REFRESH_TOKEN__FAILURE' as const;
export const REFRESH_TOKEN_RESET = 'REFRESH_TOKEN_RESET' as const;
export const LOGIN__REQUEST = 'LOGIN__REQUEST' as const;
export const LOGIN__SUCCESS = 'LOGIN__SUCCESS' as const;
export const LOGIN__FAILURE = 'LOGIN__FAILURE' as const;
export const LOGIN__RESET = 'LOGIN__RESET' as const;
export const GET_USER__REQUEST = 'GET_USER__REQUEST' as const;
export const GET_USER__SUCCESS = 'GET_USER__SUCCESS' as const;
export const GET_USER__FAILURE = 'GET_USER__FAILURE' as const;
export const GET_USER__RESET = 'GET_USER__RESET' as const;
export const LOGOUT__REQUEST = 'LOGOUT__REQUEST' as const;
export const LOGOUT__SUCCESS = 'LOGOUT__SUCCESS' as const;
export const LOGOUT__FAILURE = 'LOGOUT__FAILURE' as const;
export const LOGOUT__RESET = 'LOGOUT__RESET' as const;
export const PROFILE_UPDATE__REQUEST = 'PROFILE_UPDATE__REQUEST' as const;
export const PROFILE_UPDATE__SUCCESS = 'PROFILE_UPDATE__SUCCESS' as const;
export const PROFILE_UPDATE__FAILURE = 'PROFILE_UPDATE__FAILURE' as const;
export const PROFILE_UPDATE__RESET = 'PROFILE_UPDATE__RESET' as const;

export const MOBILE_MENU__OPEN = 'MOBILE_MENU__OPEN' as const;
export const MOBILE_MENU__CLOSE = 'MOBILE_MENU__CLOSE' as const;
